var styles = ["[_nghost-%COMP%]{display:block;overflow:hidden}"];
export { styles as styles };
